import type { Bounds } from '../map-helpers';

/**
 * Returns an "inverted" bounding box where min values are set to their maximum
 * possible values and vice versa. This serves as the initial accumulator for
 * iteratively computing the actual bounds of a set of coordinates — any real
 * coordinate will shrink the min and grow the max on the first comparison.
 *
 * @returns A {@link Bounds} object with `minLat=90`, `maxLat=-89.99`, `minLng=180`, `maxLng=-179.99`.
 */
export function getInverseBounds(): Bounds {
  return {
    minLat: 90,
    maxLat: -89.99,
    minLng: 180,
    maxLng: -179.99,
  };
}
